import type { ReactNode } from "react";
import type { Entry } from "../pages/logbook/entry/models/Entry";

// Context handed to a consumer project so it can decide whether its action applies
export interface LogbookEntryActionsContext {
	entry: Entry;
	isNewEntry: boolean;
	isDirty: boolean;
	// Triggers the same submit the Save button uses, so an action can save first
	requestSave: () => void;
}

export interface LogbookEntrySettings {
	withAssetFilter?: "tree" | "selector";
	filterAssets?: "area";
	canEditAsset?: boolean;
	presetAssetId?: number;
	allowAttachments?: boolean;
	canEditShift?: boolean;
	showShiftCrew?: boolean;
	exportToExcel?: boolean;
	shiftsRange?: number;
	useShiftNavigatorBasedOnAsset?: boolean;
	// Optional slot for project-specific actions in the entry footer
	entryActions?: (context: LogbookEntryActionsContext) => ReactNode;
}

export interface LogbookReportSettings {
	withAssetFilter?: "tree" | "selector";
	filterAssets?: "area";
	showAttachments?: boolean;
	showAsset?: boolean;
	showShiftCrew?: boolean;
	exportToExcel?: boolean;
}

export interface LogbookSectionSettings {
	schema?: string;
	withAssetFilter?: "tree" | "selector";
	filterAssets?: "area";
	canEditAsset?: boolean;
	allowAttachments?: boolean;
	showShiftCrew?: boolean;
	exportToExcel?: boolean;
	topSectionsCount?: number;
}

export interface LogbookSettingsState {
	entry: LogbookEntrySettings;
	report: LogbookReportSettings;
	section: LogbookSectionSettings;
}

export const LogbookSettingsInitialState: LogbookSettingsState = {
	entry: {
		withAssetFilter: undefined,
		filterAssets: undefined,
		canEditAsset: false,
		allowAttachments: false,
		canEditShift: false,
		showShiftCrew: false,
		exportToExcel: false,
		shiftsRange: 7,
		presetAssetId: undefined,
		useShiftNavigatorBasedOnAsset: false,
		entryActions: undefined,
	},
	report: {
		withAssetFilter: undefined,
		filterAssets: undefined,
		showAttachments: false,
		showAsset: false,
		showShiftCrew: false,
		exportToExcel: false,
	},
	section: {
		schema: undefined,
		withAssetFilter: undefined,
		filterAssets: undefined,
		canEditAsset: false,
		allowAttachments: false,
		showShiftCrew: false,
		exportToExcel: false,
		topSectionsCount: 5,
	},
};
